import { locateID } from "@xbs/lib-dom";
import { isDefined, isSameId } from "../helpers";
export function listEditor(node, config) {
    if (config.readonly)
        return;
    const store = config.api;
    const handleClick = (event) => {
        const id = locateID(event.target, "data-list-editor-id");
        const date = locateID(event.target, "data-date");
        const { stateEditableItem } = store.getState();
        if (date && !isDefined(stateEditableItem)) {
            store.exec("open-inline-editor", {
                id,
                type: "task",
                targetDate: date,
            });
        }
        if (stateEditableItem?.type === "task" &&
            !isSameId(stateEditableItem?.id, id) &&
            !stateEditableItem?.dropdown) {
            store.exec("close-inline-editor", {
                id: stateEditableItem.id,
                save: true,
            });
        }
    };
    const handleDblClick = (event) => {
        const id = locateID(event.target, "data-list-editor-id");
        const { stateEditableItem: stateEditableItem } = store.getState();
        if (!isSameId(stateEditableItem?.id, id)) {
            store.exec("open-inline-editor", {
                id,
                type: "task",
            });
        }
    };
    node.addEventListener("click", handleClick);
    node.addEventListener("dblclick", handleDblClick);
    return {
        destroy() {
            node.removeEventListener("click", handleClick);
            node.removeEventListener("dblclick", handleDblClick);
        },
    };
}
//# sourceMappingURL=listEditor.js.map